import anime from 'animejs/lib/anime.es.js';
import { sliceHTMLElements } from '../../js/helpers';

const ElementPageAnime = reductionPercent => {
	const mobileMedia = '(max-width: 999px)';
	const isSmallScreenMediaQuery = window.matchMedia(mobileMedia);
	let isSmallScreen = isSmallScreenMediaQuery.matches;

	window.addEventListener('resize', () => {
		isSmallScreen = isSmallScreenMediaQuery.matches;
	});

	const elementReduction = document.querySelector(
		'.tos-element__middle-reduction',
	);
	const elementTitle = document.querySelector('.tos-element__title');
	const elementSubtitle = document.querySelector('.tos-element__subtitle');
	const separatorText = document.querySelector('.tos-element__separator span');
	const middleText = document.querySelector(
		'.tos-element__middle-reduction-text',
	);
	const topTitles = document.querySelectorAll('.tos-element__top-text');
	const bottomElements = document.querySelector('.tos-element__bottom');

	sliceHTMLElements(elementTitle);
	sliceHTMLElements(separatorText);
	sliceHTMLElements(middleText);

	if (!isSmallScreen) {
		Array.from(topTitles).forEach(element => {
			if (topTitles) {
				sliceHTMLElements(element);
			}
		});
	}

	const tl = anime.timeline({
		easing: 'easeInOutQuad',
		duration: 500,
	});

	tl.add({
		targets: '.tos-element',
		opacity: [0, 1],
	});

	tl.add({
		targets: '.tos-element__title .sliced-element',
		opacity: [0, 1],
		delay: (_, i) => 50 * (i + 1),
	});

	if (elementSubtitle) {
		sliceHTMLElements(elementSubtitle);
		tl.add({
			targets: '.tos-element__subtitle .sliced-element',
			opacity: [0, 1],
			delay: (_, i) => 20 * (i + 1),
		});
	}

	tl.add({
		targets: '.tos-element__buttons',
		opacity: [0, 1],
	});

	if (!isSmallScreen) {
		tl.add(
			{
				targets: '.tos-element__top-text--left .sliced-element',
				opacity: [0, 1],
				delay: (_, i) => 20 * (i + 1),
			},
			'-=500',
		);
	}

	tl.add({
		targets: '.tos-element__separator .sliced-element',
		opacity: [0, 1],
		delay: (_, i) => 20 * (i + 1),
	});
	tl.add({
		targets: '.tos-element__separator-line',
		opacity: [0, 1],
		scale: [0, 1],
	});

	if (!isSmallScreen) {
		tl.add({
			targets: '.tos-element__top-text--right .sliced-element',
			opacity: [0, 1],
			delay: (_, i) => 20 * (i + 1),
		});
	}

	tl.add(
		{
			targets: '.tos-element-video .tos-video',
			opacity: [0, 1],
			duration: 2500,
		},
		!isSmallScreen ? '-=2500' : '-=4000',
	);

	tl.add(
		{
			targets: '.cmp-element__tooltip',
			opacity: [0, 1],
		},
		!isSmallScreen ? '-=0' : '-=3000',
	);

	Array.from(bottomElements.children).forEach(element => {
		if (element) {
			tl.add(
				{
					targets: element,
					opacity: [0, 1],
					translateY: [-25, 0],
				},
				'-=3500',
			);
			Array.from(element.children).forEach(elm => {
				if (elm) {
					tl.add(
						{
							targets: elm,
							opacity: [0, 1],
						},
						'-=2500',
					);
				}
			});
		}
	});

	tl.add(
		{
			targets: '.tos-element__middle',
			translateY: [-50, 0],
			opacity: [0, 1],
		},
		'-=500',
	);

	if (elementReduction) {
		tl.add(
			{
				targets: '.tos-element__middle-reduction',
				innerHTML: [0.0, reductionPercent],
				easing: 'easeInOutExpo',
				round: 10,
				duration: 5000,
				opacity: [0, 1],
				complete: function () {
					if (reductionPercent) {
						elementReduction.innerText = reductionPercent;
					}
				},
			},
			'-=1000',
		);
	}

	tl.add({
		targets: '.tos-element__middle-top',
		opacity: [0, 1],
	});

	tl.add(
		{
			targets: '.tos-element__middle-percent',
			opacity: [0, 1],
		},
		'-=1500',
	);

	tl.add({
		targets: '.tos-element__middle-reduction-text .sliced-element',
		opacity: [0, 1],
		delay: (_, i) => 20 * (i + 1),
	});

	tl.add(
		{
			targets: '.tos-element__middle__tooltip',
			opacity: [0, 1],
		},
		'-=750',
	);

	tl.add({
		targets: '.tos-element__pagination',
		opacity: [0, 1],
	});
};

export default ElementPageAnime;
